// extracted by mini-css-extract-plugin
module.exports =  {"root":"SGBpu8BeiAT1EQj7cwcS"};